import React from 'react';
import { FaClock } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';

/**
 * Estado de espera (sin parámetros)
 */
const WaitingState = ({ t }) => {
  return (
    <>
      <S.StatusIcon $status="waiting">
        <FaClock />
      </S.StatusIcon>
      <S.Title>{t('gracias.waiting.title')}</S.Title>
      <S.Message>{t('gracias.waiting.message')}</S.Message>
      <S.SubMessage>{t('gracias.waiting.submessage')}</S.SubMessage>
      
      <S.LoadingSpinner />
    </>
  );
};

export default WaitingState;

